<template>
  <div class="contract-giveaway-bd">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('crm_contract_giveaway.qsrsbjsh')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table :data="tableList" tableCode="contractGiveawayList" :slots="['billTerm']">
        <template slot="billTerm" slot-scope="scope">
          <span>{{ scope.row.billTermNum || '-' }}/{{ scope.row.billTotalTerm || '-' }}</span>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  name: '',
  props: {
    detail: {
      type: Object,
      default() {
        return {};
      },
    },
    rule: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      formSearch: {
        orderId: '',
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 20,
        pageNum: 1,
      },
      tableList: [],
      totalRows: 0,
    };
  },
  mounted: function () {
    this.getFuncView();
    this.formSearch.orderId = this.getJump('contractId');
    this.getTableList();
    this.Bus.$on('contract_device', () => {
      this.onPageChange({ page: 1 });
    });
  },
  methods: {
    // 获取表格数据列表
    getTableList: function () {
      this.$getJSON(apis.contractGiveawayList, this.formSearch).then((res) => {
        this.tableList = res.data.list || [];
        this.totalRows = null;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
  },
};
</script>

<style lang="scss">
@import 'style/colors.scss';

.contract-giveaway-bd {
  background-color: #ffffff;
  padding: 0 24px;
  .change-title {
    padding: 24px 0;
  }
}
</style>
